import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const KEY = "mg-cookie-consent";

const applyAnalytics = (enabled) => {
  const ph = window.posthog;
  if (!ph) return;
  if (enabled) ph.opt_in_capturing?.();
  else ph.opt_out_capturing?.();
};

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(KEY);
    if (!stored) setVisible(true);
    if (stored === "necessary") applyAnalytics(false);
  }, []);

  const decide = (choice) => {
    localStorage.setItem(KEY, choice);
    applyAnalytics(choice === "all");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label="Cookie notice"
      data-testid="cookie-banner"
      className="fixed inset-x-0 bottom-0 z-[70] border-t border-slate-200 bg-white/95 px-4 py-5 shadow-[0_-8px_30px_rgba(15,23,42,0.08)] backdrop-blur sm:px-6"
    >
      <div className="mx-auto flex max-w-7xl flex-col gap-4 md:flex-row md:items-center md:justify-between">
        <p className="max-w-3xl text-sm leading-relaxed text-slate-600">
          This website uses strictly necessary cookies to function and may use privacy-conscious
          analytics to understand how the site is used. We do not use advertising cookies. Read our{" "}
          <Link to="/cookie-policy" data-testid="cookie-banner-policy-link" className="font-medium text-brand hover:underline">
            Cookie Policy
          </Link>{" "}
          and{" "}
          <Link to="/privacy-policy" data-testid="cookie-banner-privacy-link" className="font-medium text-brand hover:underline">
            Privacy Policy
          </Link>
          .
        </p>
        <div className="flex gap-3">
          <button
            type="button"
            onClick={() => decide("necessary")}
            data-testid="cookie-necessary-button"
            className="btn-outline px-5 py-2.5 text-sm"
          >
            Necessary Only
          </button>
          <button
            type="button"
            onClick={() => decide("all")}
            data-testid="cookie-accept-button"
            className="btn-primary px-5 py-2.5 text-sm"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};
